import React from "react";
import ReactDOM from "react-dom";
import SesizariForm from "./SesizariForm";

export default class Sesizari extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      data: [],
      showModal: false
    };
  }

  render() {
    return (
      <>
        <div className="col">
          <SesizariForm />
        </div>
      </>
    );
  }
}

if (document.getElementById("sesizari")) ReactDOM.render(<Sesizari />, document.getElementById("sesizari"));
